<!-- <section id="main-section" class="pd-t40 pd-b40 pd-l40 pd-r40 pd-sm-20 lightgrey-bg"> -->
    <form #feedbackForm="ngForm" (ngSubmit)="submit()">
        <div class="smallContainer mg-auto">
            <!-- Congratulations Section -->
            <article class="congo-wrap">
                <div class="congo-wrap__banner">
                    <div class="d-flex">
                       <div><img src="assets/images/program-feedback-form-icon.png" alt="" /></div>
                        <div class="congo-wrap__banner--cont">
                            <h2>Kudos, {{user?.firstName}}!</h2>
                          <p>Congratulations on completing the course. THIS<strong>{{title | titlecase}}</strong>!</p>
                            <p class="share hide-on-mobile">We’d love your feedback on the course. It will help us improve the learning experience, for you and others.
                            </p>
                        </div>
                    </div>
                    <!-- <div class="congo-wrap__banner--text d-flex hide-on-desktop">Your course score is being generated. To
                        view score, please share your feedback and help us
                        improve.</div> -->
                </div>
            </article>
            <!-- Rating Section -->
            <article class="feedback-rating">
                <div class="feedback-rating__ques mandatoryIcon">
                    Please rate the overall experience of the course.
                </div>
                <div class="rating-icon" [(ngModel)]="feedback.rating" name="rating" ngDefaultControl required>
                    <span class="icon-star cursor-pointer" *ngFor="let item of stars; let i=index"
                        [ngClass]="{'rating-selected': feedback.rating >= i+1}" (click)="startClicked(i+1)">
                        <span *ngIf="feedback.rating == i+1 && feedback.rating == 1">Unhappy</span>
                        <span *ngIf="feedback.rating == i+1 && feedback.rating == 2">Dissatisfied</span>
                        <span *ngIf="feedback.rating == i+1 && feedback.rating == 3">Okay</span>
                        <span *ngIf="feedback.rating == i+1 && feedback.rating == 4">Satisfied</span>
                        <span *ngIf="feedback.rating == i+1 && feedback.rating == 5">Thrilled</span>
                    </span>
                </div>
            </article>

            <article class="feedback-wrap">
                <!-- Answer Section -->
                <div class="feedback-content">
                    <h2 class="feedback-content__ques mandatoryIcon">1. Through the course, I have learnt. </h2>
                    <div class="feedback-content__ans">
                        <ul>
                            <li>
                                <label class="radio-cont">
                                    <!-- checked="checked" -->
                                    <input type="radio" name="radio" [(ngModel)]="feedback.courseLearning" value="Something Totally New" />
                                    <span class="checkmark"></span>
                                    <span class="ans--text">Something Totally New</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                            <li>
                                <label class="radio-cont">
                                    <input type="radio" name="radio" [(ngModel)]="feedback.courseLearning" value="Something Interesting"/> <span
                                        class="checkmark"></span>
                                    <span class="ans--text">Something Interesting</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                            <li>
                                <label class="radio-cont">
                                    <input type="radio" name="radio" [(ngModel)]="feedback.courseLearning" value="Nothing At All"/><span
                                        class="checkmark"></span>
                                    <span class="ans--text">Nothing At All</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- Answer Section End -->

                <!-- Answer Section -->
                <div class="feedback-content">
                    <h2 class="feedback-content__ques mandatoryIcon">2. The case studies and examples in the course are
                    </h2>
                    <div class="feedback-content__ans">
                        <ul>
                            <li>
                                <label class="radio-cont">
                                    <input type="radio" name="radio2" [(ngModel)]="feedback.courseCaseStudies" value="Very Useful"/>
                                    <span class="checkmark"></span>
                                    <span class="ans--text">Very Useful</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                            <li>
                                <label class="radio-cont">
                                    <input type="radio" name="radio2" [(ngModel)]="feedback.courseCaseStudies" value="Useful"/><span class="checkmark"></span>
                                    <span class="ans--text">Useful</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                            <li>
                                <label class="radio-cont">
                                    <input type="radio" name="radio2" [(ngModel)]="feedback.courseCaseStudies" value="Not Useful"/><span class="checkmark"></span>
                                    <span class="ans--text">Not Useful</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- Answer Section End -->
                <!-- Answer Section -->
                <div class="feedback-content">
                    <h2 class="feedback-content__ques mandatoryIcon">
                        3. The exercises helped me in understanding the concepts better
                    </h2>
                    <!-- <p class="feedback-content__select opaacity-0">Choose as many as you like</p> -->
                    <div class="feedback-content__ans">
                        <ul>
                            <li>
                                <label class="radio-cont">
                                    <input type="radio" name="radio3" [(ngModel)]="feedback.exercisesHelped"
                                        value="Strongly Agree" />
                                    <span class="checkmark"></span>
                                    <span class="ans--text">Strongly Agree</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                            <li>
                                <label class="radio-cont">
                                    <input type="radio" name="radio3" [(ngModel)]="feedback.exercisesHelped"
                                        value="Agree" />
                                    <span class="checkmark"></span>
                                    <span class="ans--text">Agree</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                            <li>
                                <label class="radio-cont">
                                    <input type="radio" name="radio3" [(ngModel)]="feedback.exercisesHelped"
                                        value="Disagree" /><span class="checkmark"></span>
                                    <span class="ans--text">Disagree</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- Answer Section End -->
                <!-- Answer Section -->
                <div class="feedback-content">
                    <h2 class="feedback-content__ques mandatoryIcon">
                        4. Which elements did you find useful in the course?
                    </h2>
                    <!-- <p class="feedback-content__select">Choose as many as you like</p> -->
                    <div class="feedback-content__ans">
                        <ul>
                            <li>
                                <label class="radio-cont">
                                    <input type="checkbox" name="radio4"
                                     (click)="selectElement('Course Content')"/>
                                    <span class="checkmark"></span>
                                    <span class="radio-cont__color"></span>
                                    <span class="ans--text">Course Content</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                            <li>
                                <label class="radio-cont">
                                    <input type="checkbox" name="radio4" (click)="selectElement('Faculty Videos')"/>
                                    <span class="checkmark"></span>
                                    <span class="ans--text">Faculty Videos</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                            <li>
                                <label class="radio-cont">
                                    <input type="checkbox" name="radio4"
                                     (click)="selectElement('Assessments')"/><span class="checkmark"></span>
                                    <span class="ans--text">Assessments</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                            <li>
                                <label class="radio-cont">
                                    <input type="checkbox" name="radio4"
                                    (click)="selectElement('Downloadable Resources')" /><span class="checkmark"></span>
                                    <span class="ans--text">Downloadable Resources</span>
                                    <div class="ans--active"></div>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- Answer Section End -->
                <!-- Answer Section -->
                <div class="feedback-content">
                    <h2 class="feedback-content__ques">5. What do you think must be significantly improved in this course?</h2>
                    <p class="feedback-content__select">Optional</p>
                    <div class="feedback-content__ans">
                        <input type="text" name="significantlyImproved" placeholder="Type your answer here..." [(ngModel)]="feedback.significantlyImproved"
                    />
                    </div>
                </div>
                <!-- Answer Section End -->
                <!-- Answer Section -->
                <!-- Answer Section End -->

                <!-- Answer Section -->
                <div class="feedback-content terms-check--cont d-flex justify-content-between">
                    <div class="feedback-content__ans">
                        <label class="checkbox-cont">
                            <input type="checkbox" name="testimonial" [(ngModel)]="feedback.testimonial">
                            <span class="checkbox-check"></span>
                        </label>
                    </div>
                    <div class="feedback-content__ans  terms--cont ">
                        <p class="feedback-content__ans__text">Please check this box if you would like us to stay in touch with you to regularly discuss your progress. we will reach out to you via email for quick interviews and testimonials.</p>
                    </div>
                </div>
                <!-- Answer Section End -->
                <!-- Terms Section -->
                <!-- <div class="feedback-content terms--cont hide-on-mobile">
                    <div class="feedback-content__ans">
                        <p class="feedback-content__ans__text">Would like us to stay in touch with you to regularly discuss
                            your progress. We will reach
                            out to you via email for quick interviews and testimonials.</p>
                    </div>
                </div> -->
                <!-- Terms Section End -->
                <!-- Footer Button Section -->
                <div class="feedback-content feedback--button">
                    <!-- <button type="button"
                        class="light-color link-no-underline trans--button pd-t10 pd-b10 pd-l20 pd-r20">Back</button> -->
                    <button type="submit"
                        class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20">Submit</button>
                </div>
                <!-- Footer Button Section End -->

            </article>
        </div>
    </form>
    <!-- </section> -->
